export default {
  header: 'Vorab, möchtest du eine Papier-Stempelkarte digitaliseren?',
  buttons: {
    yes: 'Ja',
    no: 'Nein',
  },
};
